import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exportingInit from 'highcharts/modules/exporting';
import exportDataInit from 'highcharts/modules/export-data';

// Initialize the exporting and export data modules
exportingInit(Highcharts);
exportDataInit(Highcharts);

const DisaggregatedFlexibilityChart = ({ data }) => {
    const [chartOptions, setChartOptions] = useState(null);

    useEffect(() => {
        if (!data || !data.flexibility_timestamps || !data.flexibility_percentage) {
            return;
        }

        // Transform the data into chart format
        const chartData = data.flexibility_timestamps.map((timestamp, index) => {
            return [
                new Date(timestamp).getTime(),
                data.flexibility_percentage[index]
            ];
        });

        setChartOptions({
            chart: {
                type: 'line',
                zoomType: 'x'
            },
            title: {
                text: null
            },
            xAxis: {
                type: 'datetime',
                title: {
                    text: 'Time'
                },
                dateTimeLabelFormats: {
                    hour: '%H:%M',
                    day: '%e %b %H:%M'
                }
            },
            yAxis: {
                title: {
                    text: 'Flexibility Percentage (%)'
                },
                min: 0,
                max: 100
            },
            tooltip: {
                headerFormat: '<b>{series.name}</b><br/>',
                pointFormat: '{point.x:%e %b %Y %H:%M}: <b>{point.y:.2f}%</b>'
            },
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: false
                    },
                    marker: {
                        enabled: true,
                        radius: 3
                    }
                }
            },
            series: [{
                name: 'Flexibility Percentage',
                data: chartData,
                color: '#009688', // Teal - distinct from all appliance colors
                lineWidth: 2,
                marker: {
                    symbol: 'circle'
                }
            }],
            exporting: {
                enabled: true
            },
            credits: {
                enabled: false
            },
            accessibility: {
                enabled: false
            }
        });
    }, [data]);

    if (!chartOptions || !data) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '300px',
                color: '#666'
            }}>
                No flexibility data available
            </div>
        );
    }

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
            containerProps={{ style: { height: '400px', width: '100%' } }}
        />
    );
};

export default DisaggregatedFlexibilityChart; 